import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export default function Pricing() {
  return (
    <>
      <Helmet>
        <title>Pricing - TEJ Solutions Hub | Transparent Pricing for All Services</title>
        <meta name="description" content="Transparent pricing for web development, mobile apps, digital marketing, cloud infrastructure, and SMS campaigns. Custom solutions for every budget." />
      </Helmet>

      <div style={{ paddingTop: '100px', background: '#f9fafb', minHeight: '100vh' }}>
        <div style={{ background: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)', padding: '4rem 2rem', color: 'white', textAlign: 'center' }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <h1 style={{ fontSize: '3rem', fontWeight: '800', marginBottom: '1rem' }}>Pricing & Plans</h1>
            <p style={{ fontSize: '1.25rem', opacity: '0.95', maxWidth: '700px', margin: '0 auto' }}>
              Flexible pricing designed for businesses of all sizes
            </p>
          </div>
        </div>

        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '4rem 2rem' }}>
          {/* Service Packages */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem', marginBottom: '4rem' }}>
            
            {/* Starter Package */}
            <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', border: '2px solid #e5e7eb' }}>
              <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>🚀</div>
              <h2 style={{ fontSize: '1.75rem', fontWeight: '700', color: '#1f2937', marginBottom: '0.5rem' }}>Starter</h2>
              <p style={{ fontSize: '0.95rem', color: '#6b7280', marginBottom: '2rem' }}>Perfect for small businesses</p>
              
              <div style={{ marginBottom: '2rem' }}>
                <div style={{ fontSize: '2.5rem', fontWeight: '800', color: '#7c3aed', marginBottom: '0.5rem' }}>
                  Starting at
                </div>
                <div style={{ fontSize: '2rem', fontWeight: '700', color: '#1f2937' }}>$2,500</div>
                <div style={{ fontSize: '0.95rem', color: '#6b7280', marginTop: '0.5rem' }}>Per project</div>
              </div>

              <ul style={{ fontSize: '1rem', color: '#4b5563', lineHeight: '2.5', paddingLeft: '0', listStyle: 'none', marginBottom: '2rem' }}>
                <li>✓ Basic website or landing page</li>
                <li>✓ Responsive design</li>
                <li>✓ Up to 5 pages</li>
                <li>✓ Basic SEO setup</li>
                <li>✓ 30 days support</li>
                <li>✓ Email support</li>
              </ul>

              <Link to="/contact" style={{
                display: 'block',
                textAlign: 'center',
                background: 'white',
                color: '#7c3aed',
                padding: '1rem',
                borderRadius: '8px',
                textDecoration: 'none',
                fontWeight: '600',
                border: '2px solid #7c3aed',
                transition: 'all 0.3s ease'
              }}>
                Get Started
              </Link>
            </div>

            {/* Professional Package */}
            <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 8px 30px rgba(124, 58, 237, 0.2)', border: '3px solid #7c3aed', position: 'relative' }}>
              <div style={{ position: 'absolute', top: '-15px', left: '50%', transform: 'translateX(-50%)', background: '#fbbf24', color: '#1f2937', padding: '0.5rem 1.5rem', borderRadius: '50px', fontSize: '0.85rem', fontWeight: '700' }}>
                MOST POPULAR
              </div>
              <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>⭐</div>
              <h2 style={{ fontSize: '1.75rem', fontWeight: '700', color: '#1f2937', marginBottom: '0.5rem' }}>Professional</h2>
              <p style={{ fontSize: '0.95rem', color: '#6b7280', marginBottom: '2rem' }}>For growing businesses</p>
              
              <div style={{ marginBottom: '2rem' }}>
                <div style={{ fontSize: '2.5rem', fontWeight: '800', color: '#7c3aed', marginBottom: '0.5rem' }}>
                  Starting at
                </div>
                <div style={{ fontSize: '2rem', fontWeight: '700', color: '#1f2937' }}>$7,500</div>
                <div style={{ fontSize: '0.95rem', color: '#6b7280', marginTop: '0.5rem' }}>Per project</div>
              </div>

              <ul style={{ fontSize: '1rem', color: '#4b5563', lineHeight: '2.5', paddingLeft: '0', listStyle: 'none', marginBottom: '2rem' }}>
                <li>✓ Custom web/mobile app</li>
                <li>✓ Advanced features</li>
                <li>✓ Unlimited pages</li>
                <li>✓ SEO & marketing setup</li>
                <li>✓ 90 days support</li>
                <li>✓ Priority support</li>
                <li>✓ API integrations</li>
                <li>✓ Analytics setup</li>
              </ul>

              <Link to="/contact" style={{
                display: 'block',
                textAlign: 'center',
                background: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)',
                color: 'white',
                padding: '1rem',
                borderRadius: '8px',
                textDecoration: 'none',
                fontWeight: '600',
                transition: 'all 0.3s ease'
              }}>
                Get Started
              </Link>
            </div>

            {/* Enterprise Package */}
            <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', border: '2px solid #e5e7eb' }}>
              <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>🏢</div>
              <h2 style={{ fontSize: '1.75rem', fontWeight: '700', color: '#1f2937', marginBottom: '0.5rem' }}>Enterprise</h2>
              <p style={{ fontSize: '0.95rem', color: '#6b7280', marginBottom: '2rem' }}>For large organizations</p>
              
              <div style={{ marginBottom: '2rem' }}>
                <div style={{ fontSize: '2.5rem', fontWeight: '800', color: '#7c3aed', marginBottom: '0.5rem' }}>
                  Custom
                </div>
                <div style={{ fontSize: '1.5rem', fontWeight: '600', color: '#1f2937', marginTop: '0.5rem' }}>Contact Sales</div>
                <div style={{ fontSize: '0.95rem', color: '#6b7280', marginTop: '0.5rem' }}>Based on requirements</div>
              </div>

              <ul style={{ fontSize: '1rem', color: '#4b5563', lineHeight: '2.5', paddingLeft: '0', listStyle: 'none', marginBottom: '2rem' }}>
                <li>✓ Full-scale solutions</li>
                <li>✓ Custom development</li>
                <li>✓ Cloud infrastructure</li>
                <li>✓ Dedicated team</li>
                <li>✓ 24/7 support</li>
                <li>✓ SLA guarantees</li>
                <li>✓ White-label options</li>
                <li>✓ Ongoing maintenance</li>
              </ul>

              <Link to="/contact" style={{
                display: 'block',
                textAlign: 'center',
                background: 'white',
                color: '#7c3aed',
                padding: '1rem',
                borderRadius: '8px',
                textDecoration: 'none',
                fontWeight: '600',
                border: '2px solid #7c3aed',
                transition: 'all 0.3s ease'
              }}>
                Contact Sales
              </Link>
            </div>
          </div>

          {/* Service-Specific Pricing */}
          <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: '4rem' }}>
            <h2 style={{ fontSize: '2rem', fontWeight: '700', color: '#1f2937', marginBottom: '2rem', textAlign: 'center' }}>
              Service-Specific Pricing
            </h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '2rem' }}>
              <div style={{ padding: '1.5rem', background: '#f9fafb', borderRadius: '12px', border: '2px solid #7c3aed' }}>
                <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#7c3aed', marginBottom: '1rem' }}>Digital Marketing</h3>
                <div style={{ fontSize: '1.5rem', fontWeight: '700', color: '#1f2937', marginBottom: '0.5rem' }}>$1,500/mo</div>
                <p style={{ fontSize: '0.9rem', color: '#6b7280' }}>SEO, social media, content marketing</p>
              </div>
              <div style={{ padding: '1.5rem', background: '#f9fafb', borderRadius: '12px', border: '2px solid #7c3aed' }}>
                <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#7c3aed', marginBottom: '1rem' }}>Email Marketing</h3>
                <div style={{ fontSize: '1.5rem', fontWeight: '700', color: '#1f2937', marginBottom: '0.5rem' }}>$800/mo</div>
                <p style={{ fontSize: '0.9rem', color: '#6b7280' }}>Campaign design, automation, analytics</p>
              </div>
              <div style={{ padding: '1.5rem', background: '#f9fafb', borderRadius: '12px', border: '2px solid #7c3aed' }}>
                <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#7c3aed', marginBottom: '1rem' }}>SMS Campaigns</h3>
                <div style={{ fontSize: '1.5rem', fontWeight: '700', color: '#1f2937', marginBottom: '0.5rem' }}>$0.02/msg</div>
                <p style={{ fontSize: '0.9rem', color: '#6b7280' }}>A2P compliant, bulk messaging</p>
              </div>
              <div style={{ padding: '1.5rem', background: '#f9fafb', borderRadius: '12px', border: '2px solid #7c3aed' }}>
                <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#7c3aed', marginBottom: '1rem' }}>Cloud Management</h3>
                <div style={{ fontSize: '1.5rem', fontWeight: '700', color: '#1f2937', marginBottom: '0.5rem' }}>$1,200/mo</div>
                <p style={{ fontSize: '0.9rem', color: '#6b7280' }}>AWS/Azure/GCP management</p>
              </div>
            </div>
          </div>

          {/* What's Included */}
          <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: '4rem' }}>
            <h2 style={{ fontSize: '2rem', fontWeight: '700', color: '#1f2937', marginBottom: '2rem', textAlign: 'center' }}>
              All Plans Include:
            </h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '2rem' }}>
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>✓</div>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>Quality Assurance</h3>
                <p style={{ fontSize: '0.95rem', color: '#6b7280' }}>Thorough testing and QA</p>
              </div>
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>✓</div>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>Documentation</h3>
                <p style={{ fontSize: '0.95rem', color: '#6b7280' }}>Complete project docs</p>
              </div>
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>✓</div>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>Training</h3>
                <p style={{ fontSize: '0.95rem', color: '#6b7280' }}>Team training included</p>
              </div>
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>✓</div>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>Compliance</h3>
                <p style={{ fontSize: '0.95rem', color: '#6b7280' }}>Full regulatory compliance</p>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div style={{ background: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)', padding: '4rem 3rem', borderRadius: '16px', textAlign: 'center', color: 'white' }}>
            <h2 style={{ fontSize: '2.5rem', fontWeight: '800', marginBottom: '1rem' }}>Not Sure Which Plan is Right?</h2>
            <p style={{ fontSize: '1.1rem', opacity: '0.95', marginBottom: '2rem', maxWidth: '600px', margin: '0 auto 2rem' }}>
              Contact us for a free consultation and custom quote based on your specific needs
            </p>
            <Link to="/contact" style={{
              display: 'inline-block',
              background: '#fbbf24',
              color: '#1f2937',
              padding: '1.25rem 3rem',
              borderRadius: '12px',
              textDecoration: 'none',
              fontWeight: '700',
              fontSize: '1.1rem',
              boxShadow: '0 8px 24px rgba(251, 191, 36, 0.4)'
            }}>
              Get Free Consultation
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
